import React, { Component } from 'react';
import { findDOMNode } from 'react-dom'
import {Box} from 'reactjs-admin-lte'
import {Button,DropdownButton,MenuItem,FormGroup,Row,Col,Tabs,Tab,Form,Breadcrumb,Popover,OverlayTrigger} from 'react-bootstrap'
import Select from 'react-select';
import FontAwsome from 'react-fontawesome'
import { Radio,RadioGroup } from 'react-icheck';
import Chart from 'chart.js';
import ReportStore from '../../stores/ReportStore';
import { momentHelper } from '../report/helpers'
import Moment from 'moment'
import SelectDate from 'component/element/SelectDate'
import PrintButtons from 'component/element/PrintButtons'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import DatePicker from 'component/element/DatePicker'
import './Dashboard.css';
import JSWorkDocViewModal from 'view/workdoc/JSWorkdocViewModal';
import IframeModal from 'component/element/IframeModal'
const localStorageKey = 'kkc.main-dashboard-view-form'
const WHOLE_YEAR = momentHelper.getMonth()
const api = require('api')
const messages = api.getMessage().view.dashboard.MainDashboard;
const workStatusCfg = {"0":{title:messages['Start'],color:"#b5bbc8"},
            "1":{title:messages['Under Repair'],color:"#ff851b"},
            "2":{title:messages['Waiting deliver'],color:"#337AB7"},
            "3":{title:messages['Work Done'],color:"#00a65a"},
            "5":{title:messages['Set payment'],color:"#800080"},
            "6":{title:messages['Hold quotation'],color:"#d3d3d3"},
            "7":{title:messages['Not out of job'],color:"#8a6d3b"},
            "8":{title:messages['Car not park'],color:"pink"},
            "-1":{title:messages['Cancel'],color:"#f56954"},
          }
const monthsLabel  = [messages['January'], messages['February'], messages['March'], messages['April'], messages['May'], messages['June'], messages['July'], messages['August'], messages['September'], messages['October'], messages['November'], messages['December']]
const paymentType = {"CASH":{title:messages['Cash'],color:"#b5bbc8"},"CREDIT":{title:messages['Credit'],color:"#00a65a"},"INSURER":{title:messages['Use insurance'],color:"purple"}
,"GOVERNMENT":{title:messages['Government'],color:"red"},"INDUSTRY":{title:messages['Industry'],color:"yellow"}} 

class MainDashboard extends Component {

  constructor(props) {
    super(props)
    const yTh = (Moment().format('YYYY')*1) + 543
    const yEn = Moment().format('YYYY')
    const M = Moment().format('MM')
    const yearPastLabel = []
    let y = yTh - 1;
    for (var i=y;i>=2560;i--) {
      if (i!==yTh) {
        yearPastLabel.push(i)
      }  
    }

    this.state = {
      payment_type:[],
      income:[],
      cpw:[],
      spw:[],
      chartdata:[],
      chartdata2:[],
      approved_chartdata:[],
      approved_chartdata2:[],
      yEn:yEn,
      yTh:yTh,
      month:M,
      month_dashboard:M,
      textM:"",
      disabled:[],
      checked:[],
      yearPastLabel:yearPastLabel,
      activeKey:0,
      activeName:'all',
      insuredata:[],
      cashdata:[],
      officerdata:[],
      isRange: false,
      day:'00',
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      checkDataFinance:false,
      checkDataReceived:false,
      insureDataType:'count',
      checkCashDataFinance:false,
      checkCashDataReceived:false,
      cashDataType:'count',
      empDataType:'count',
      amountType:'quotation',
      dataDetail:[],
      insurer_id:null,
      job_type:'work',
      showDetail:false,
      owner_id:null,
      work_owner_id:null,
      viewForm: JSON.parse(localStorage.getItem(localStorageKey)) || 'added_date',
      work_status:'',
      work_status_option:[],
      default_status:[],
      profit:{itemlist:[]}
    }
    this.doughnutChart1 = null
    this.doughnutChart2 = null
    this.doughnutChartInsure1 = null
    this.doughnutChartInsure2 = null
    this.barChart1 = null
    this.barChart2 = null
    this.loadStat('','',this.state.viewForm)
    this.setRaio()
    this.refTableId = 'ReportInsure-'+Math.ceil(Math.random()*100);
    this.refCashTableId = 'ReportCash-'+Math.ceil(Math.random()*100);
    this.refEmpTableId = 'ReportEmp-'+Math.ceil(Math.random()*100);
    this.refTableDetailId = 'ReportInsureDetail-'+Math.ceil(Math.random()*100);
    this.refCashTableDetailId = 'ReportCashDetail-'+Math.ceil(Math.random()*100);
    this.refEmpTableDetailId = 'ReportEmpDetail-'+Math.ceil(Math.random()*100);
  }

  refreshGraphCanvas() {
    this.canvas = findDOMNode(this.canvasDoughnutRef);
    this.ctx = this.canvas.getContext('2d');
    let canvas = this.canvas,ctx=this.ctx

    this.canvas2 = findDOMNode(this.canvasDoughnutRef2);
    this.ctx2 = this.canvas2.getContext('2d');
    let canvas2 = this.canvas2,ctx2=this.ctx2

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx2.clearRect(0, 0, canvas2.width, canvas2.height);

    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar

    this.canvasBar2 = findDOMNode(this.canvasBarRef2);
    this.ctxBar2 = this.canvasBar2.getContext('2d');
    let canvasBar2 = this.canvasBar2,ctxBar2=this.ctxBar2

    let {cpw,spw,chartdata,chartdata2,approved_chartdata,approved_chartdata2,payment_type,amountType} = this.state
    if(amountType==='approved'){
      chartdata = approved_chartdata;
      chartdata2 = approved_chartdata2
    }

    let data = {
      datasets:
       [{
          data: cpw.map((item,index)=>{
            return item.count_work
          }),
          backgroundColor:cpw.map((item,index)=>{
            return workStatusCfg[item.status].color
          }),
      }],
      
      labels: cpw.map((item,index)=>{
        return workStatusCfg[item.status].title
      })
    };

    let data2 = {
      datasets:
       [{
          data: spw.map((item,index)=>{
            if(amountType==='approved'){
              return item.sum_approved_amount
            }else{
              return item.sum_work
            }
          }),
          backgroundColor:spw.map((item,index)=>{
            return paymentType[item.payment_type].color
          }),
      }],
      labels: spw.map((item,index)=>{
        return paymentType[item.payment_type].title
      })
    };

    let setBar = []
    let i = 0
    chartdata.data.forEach(element => {      
      let item = paymentType[payment_type[i]]

      setBar.push({
        label: item.title,
        backgroundColor:item.color,
        data: chartdata.data[i]
      })
      i++
    })
    let dataBar = {
      labels: chartdata.labels,
      datasets: setBar
    };

    let setBar2 = []
    let j = 0
    chartdata2.data.forEach(element => {
      let label = ""
      let color = ""
      if (j===0) { 
        label = messages['Wages cost']
        color = "#b5bbc8"
      } else {
        label = messages['Parts cost']
        color = "#00a65a"
      }
      setBar2.push({
        label: label,
        backgroundColor:color,
        data: chartdata2.data[j]
      })
      j++
    })
    let dataBar2 = {
      labels: chartdata2.labels,
      datasets: setBar2
    };
    if(this.doughnutChart1!==null){
      this.doughnutChart1.destroy();
    }
    this.doughnutChart1 = new Chart(ctx, {
      type: 'doughnut',
      data: data,
      options: {
        radiusBackground: {
          color: '#d1d1d1'
        },
        cutoutPercentage: 20,
        title: {
          display: true,
        },
        legend: {
          display: true,
        },
      },
    });

    if(this.doughnutChart2!==null){
      this.doughnutChart2.destroy();
    }
    this.doughnutChart2 = new Chart(ctx2, {
      type: 'doughnut',
      data: data2,
      options: {
        radiusBackground: {
          color: '#d1d1d1'
        },
        cutoutPercentage: 20,
        title: {
          display: true,
        },
        legend: {
          display: true,
        },
      },
    });

    if(this.barChart1!==null){
      this.barChart1.destroy();
    }
    this.barChart1 = new Chart(ctxBar, {
      type: 'bar',
      data: dataBar,
      options: {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero:true
                }
            }]
        }
      }
    });

    if(this.barChart2!==null){
      this.barChart2.destroy();
    }
    this.barChart2 = new Chart(ctxBar2, {
      type: 'bar',
      data: dataBar2,
      options: {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero:true
                }
            }]
        }
      }
    });
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  getNumberFormat(value,digit=2) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,") // /\B(?=(\d{3})+(?!\d))/g, ","
  }

  getSummary(type,field) {
    let {insuredata,cashdata,officerdata} = this.state
    let data = type==='insurer'?insuredata:type==='emp'?officerdata:cashdata
    let sum = 0
    data.forEach((item,index)=>{
      let value = (item[field]!==''&&item[field]!==null&&item[field]!==undefined&&!isNaN(item[field])?item[field]:0)
      sum += (value*1)
    })
    return sum
  }

  getSummaryDetail(field) {
    let {dataDetail} = this.state
    let sum = 0
    dataDetail.forEach((item,index)=>{
      let value = (item[field]!==''&&item[field]!==null&&item[field]!==undefined&&!isNaN(item[field])?item[field]:0)
      sum += (value*1)
    })
    return sum
  }

  loadStat(year='',month='',viewForm='added_date') {
    
    ReportStore.loadStat(year,(month==='0'||month===0?'':month),viewForm,(result)=> {
      this.setState(result,()=>{
        this.refreshGraphCanvas()
      })
    })
  }

  onAmountTypeChange(e,amountType){
    this.setState({amountType:amountType},()=>{
      this.refreshGraphCanvas()
    })
  }

  onViewFormDashboardChange(e,value) {
    this.setState({viewForm:value},()=>{
      this.loadStat(this.state.year-543,this.state.month_dashboard*1,value)
      localStorage.setItem(localStorageKey, JSON.stringify(value))
    })
  }

  setInsureChart(type='insurer',labels1,labels2,datas1,datas2,backgroundColor1,backgroundColor2) {
      let _data = type==='insurer'?this.state.insuredata:type==='emp'?this.state.officerdata:this.state.cashdata
      if (_data.length>0) {
        let checkdatas1 = 0
        checkdatas1 = datas1.reduce((rresult,item,index)=>{
          checkdatas1 = parseInt(item)+parseInt(checkdatas1)
          return checkdatas1
        },[])
        let checkdatas2 = 0
        checkdatas2 = datas2.reduce((rresult,item,index)=>{
          checkdatas2 = parseInt(item)+parseInt(checkdatas2)
          return checkdatas2
        },[])
        if (checkdatas1>0) {
          if (type==='insurer')
            this.setState({checkDataFinance:true})
          else if (type==='cash')
            this.setState({checkCashDataFinance:true})
        } else {
          if (type==='insurer')
            this.setState({checkDataFinance:false})
          else if (type==='cash')
            this.setState({checkCashDataFinance:false})
        }

        if (checkdatas2>0) {
          if (type==='insurer')
            this.setState({checkDataReceived:true})
          else if (type==='cash')
            this.setState({checkCashDataReceived:true})
        } else {
          if (type==='insurer')
            this.setState({checkDataReceived:false})
          else if (type==='cash')
            this.setState({checkCashDataReceived:false})    
        }

        let data1 = {
          datasets:
          [{
              data: datas1,
              backgroundColor:backgroundColor1
          }],
          labels: labels1
        }
        let data2 = {
          datasets:
          [{
              data: datas2,
              backgroundColor:backgroundColor1
          }],
          labels: labels2
        }

        this.canvasInsure1 = type==='insurer'?findDOMNode(this.canvasInsureRef1):findDOMNode(this.canvasCashRef1)
        this.ctxInsure1 = this.canvasInsure1.getContext('2d');
        let canvasInsure1 = this.canvasInsure1,ctxInsure1=this.ctxInsure1
        if(this.doughnutChartInsure1!==null){
          this.doughnutChartInsure1.destroy();
        }
        this.doughnutChartInsure1 = new Chart(ctxInsure1, {
          type: 'doughnut',
          data: data1,
          options: {
            radiusBackground: {
              color: '#d1d1d1'
            },
            cutoutPercentage: 20,
            title: {
              display: true,
            },
            legend: {
              display: false,
            },
            plugins: {
              datalabels: {
                display: false
              }
            }
          },
        })

        this.canvasInsure2 = type==='insurer'?findDOMNode(this.canvasInsureRef2):findDOMNode(this.canvasCashRef2)
        this.ctxInsure2 = this.canvasInsure2.getContext('2d');
        let canvasInsure2 = this.canvasInsure2,ctxInsure2=this.ctxInsure2
        if(this.doughnutChartInsure2!==null){
          this.doughnutChartInsure2.destroy();
        }
        this.doughnutChartInsure2 = new Chart(ctxInsure2, {
          type: 'doughnut',
          data: data2,
          options: {
            radiusBackground: {
              color: '#d1d1d1'
            },
            cutoutPercentage: 20,
            title: {
              display: true,
            },
            legend: {
              display: false,
            },
            plugins: {
              datalabels: {
                display: false
              }
            }
          },
        })
      }  
  }

  loadInsureStat(type='insurer',year='',month='',day='',viewForm='added_date') {
    let {insureDataType,cashDataType,empDataType,work_status,work_status_option,default_status} = this.state
    let dataType = type==='insurer'?insureDataType:type==='emp'?empDataType:cashDataType
    ReportStore.loadInsureStat(type,year,month,day,viewForm,(result)=>{
      work_status_option = result.work_status_option.map((item,index)=>{
        return {label:item.detail,value:item.status_no,className:'select-value-label-'+(item.status_no==='0'?'default':item.status_no==='1'?'warning':item.status_no==='2'?'primary':item.status_no==='3'?'success':item.status_no==='5'?'purple':item.status_no==='6'?'lightgray':item.status_no==='7'?'lightyellow':item.status_no==='8'?'pink':'')}
      })
      let default_status_ = ''
      if (default_status.length===0) {
        default_status = result.default_status
        default_status_ = result.default_status.join()
      } else
        default_status_ = ''
      
      let new_work_status = default_status_+work_status
      this.setState({default_status:default_status,work_status:new_work_status,work_status_option:work_status_option})
      if (type==='insurer')
        this.setState({insuredata:result.data})
      else if (type==='cash')
        this.setState({cashdata:result.data})  
      else if (type==='emp')
        this.setState({officerdata:result.data})    
      
      let labels1 = []
      let labels2 = []
      let datas1 = []
      let datas2 = []
      let backgroundColor1 = []
      let backgroundColor2 = []
      result.data.forEach((item,index)=>{
        const finance_count = item.finance_count===null?0:item.finance_count
        const finance_amount = item.finance_amount===null?0:item.finance_amount
        const received_count = item.received_count===null?0:item.received_count
        const received_amount = item.received_amount===null?0:item.received_amount
        const shortName = type==='insurer'?item.insurer_short_name:type==='emp'?item.work_owner_by:item.owner_short_name
        labels1.push(shortName)
        labels2.push(shortName)
        datas1.push(dataType==='count'?finance_count:finance_amount)
        datas2.push(dataType==='count'?received_count:received_amount)
        backgroundColor1.push('#'+(Math.random()*0xFFFFFF<<0).toString(16))
        backgroundColor2.push('#'+(Math.random()*0xFFFFFF<<0).toString(16))
      })  
      if (type!=='emp')
        this.setInsureChart(type,labels1,labels2,datas1,datas2,backgroundColor1,backgroundColor2)
    })
  }

  loadInsureStatRange(type='insurer',start='',end='',viewForm='added_date') {
    let {insureDataType,cashDataType,empDataType} = this.state
    let dataType = type==='insurer'?insureDataType:type==='emp'?empDataType:cashDataType
    ReportStore.loadInsureStatRange(type,start,end,viewForm,(result)=>{
      if (type==='insurer')
        this.setState({insuredata:result.data})
      else if (type==='cash')
        this.setState({cashdata:result.data}) 
      let labels1 = []
      let labels2 = []
      let datas1 = []
      let datas2 = []
      let backgroundColor1 = []
      let backgroundColor2 = []
      result.data.forEach((item,index)=>{
        const finance_count = item.finance_count===null?0:item.finance_count
        const finance_amount = item.finance_amount===null?0:item.finance_amount
        const received_count = item.received_count===null?0:item.received_count
        const received_amount = item.received_amount===null?0:item.received_amount
        const shortName = type==='insurer'?item.insurer_short_name:type==='emp'?item.work_owner_by:item.owner_short_name
        labels1.push(shortName)
        labels2.push(shortName)
        datas1.push(dataType==='count'?finance_count:finance_amount)
        datas2.push(dataType==='count'?received_count:received_amount)
        backgroundColor1.push('#'+(Math.random()*0xFFFFFF<<0).toString(16))
        backgroundColor2.push('#'+(Math.random()*0xFFFFFF<<0).toString(16))
      })  
      if (type!=='emp')
        this.setInsureChart(type,labels1,labels2,datas1,datas2,backgroundColor1,backgroundColor2)
    })
  }

  loadDataDetail(type,job_type,id,year,month,day,viewForm,complete) {
    this.setState({loading:true})
    ReportStore.loadReportSummaryDetail(type,job_type,id,year,month,day,viewForm,(result)=>{
      this.setState({loading:false,dataDetail:result.data})
      complete('OK')
    })
  }

  setRaio(check='',key='') {
    let {disabled,checked,yearPastLabel,month_dashboard} = this.state
    if (check==='checked') {
      for (var i=0;i<=12;i++) {
        if (i===key) {
          disabled[i] = false
          checked[i] = true
        } else {
          disabled[i] = true
          checked[i] = false
        }
      }
      this.setState({disabled:disabled,checked:checked})
    } else {
      for (var i=0;i<=12;i++) {
        disabled[i] = true
        checked[i] = false
      }
      yearPastLabel.forEach(function(item,index) {
        disabled[item] = true
        checked[item] = false
      })
      let current = (month_dashboard*1)
      disabled[current] = false
      checked[current] = true
    }
  }

  convertMonth(month) {
    let text = ""
    if(month===0||month==='0'||month==='00'){
      let {checked} = this.state
      let findCheck = checked.indexOf(true)
      if (findCheck!==-1&&findCheck>12)
        return  messages['All Year']+" "+findCheck
      else if (findCheck!==1&&findCheck===0)
        return  messages['All Year']+" "+this.state.yTh
    }

    text = monthsLabel[month-1];
    if(text===undefined || text===null){
      text = messages['Overview']
    }
    return text
  }

  onItemSelect(e) {
    let {disabled,checked,yearPastLabel,viewForm} = this.state
    if (e>12) {
      this.setState({month_dashboard:'00'})
      this.loadStat(e-543,0,viewForm)
      disabled.forEach((item,index)=>{
        disabled[index] = true
        checked[index] = false
      })
      disabled[e] = false
      checked[e] = true
    } else {
      yearPastLabel.forEach(function(item,index) {
        disabled[item] = true
        checked[item] = false
      })
      let month_dashboard = e<10?'0'+e:e.toString()
      this.setState({month_dashboard:month_dashboard})
      this.loadStat(this.state.yEn,e,viewForm)
      this.setRaio('checked',e)
    }  
  }

  onTabSelect(key) {
    let {year,month,day,viewForm} = this.state
    this.setState({activeKey:key,activeName:(key===0?'all':key===1?'insurer':key===3?'emp':'cash'),isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
    if (key===1) {
      this.loadInsureStat('insurer',year,month,day,viewForm)
    } else if (key===2) {
      this.loadInsureStat('cash',year,month,day,viewForm)
    } else if (key===3) {
      this.loadInsureStat('emp',year,month,day,viewForm)
    }
  }

  renderHeaderOverview() {
    let {disabled,checked} = this.state
    var monthsLabelReverse = monthsLabel.slice().reverse();
    var yearPastLabelReverse = this.state.yearPastLabel.slice().reverse();
    return(
      <Box.Header border={true}>
        <Box.Title>
          <i className="fa fa-bullhorn"></i>&nbsp;
          {messages['Worksheet Overview']} -
          <DropdownButton id="dd" bsStyle="link" title={this.convertMonth(this.state.month_dashboard)} onSelect={this.onItemSelect.bind(this)}>
            <div style={{paddingLeft:'20px'}}>{messages['Overview']}</div>
            {
              yearPastLabelReverse.map((item,index)=>(
                <MenuItem key={index} eventKey={item}> 
                  <Radio
                    radioClass="iradio_flat-blue"
                    increaseArea="20%"
                    disabled={disabled[item]}
                    checked={checked[item]}
                  >
                  </Radio> {messages['All Year']} {item}
                </MenuItem>
              ))
            }
            <MenuItem eventKey={0}> 
              <Radio
                radioClass="iradio_flat-blue"
                increaseArea="20%"
                disabled={disabled[0]}
                checked={checked[0]}
              >
              </Radio> {messages['All Year']} {this.state.yTh}
            </MenuItem>
            {
              monthsLabelReverse.map((item,index)=>(
                <MenuItem key={index} eventKey={(12-index)}> 
                  <Radio
                    radioClass="iradio_flat-blue"
                    increaseArea="20%"
                    disabled={disabled[12-index]}
                    checked={checked[12-index]}
                  >
                  </Radio> {item}
                </MenuItem>
              ))
            }   

          </DropdownButton>
        </Box.Title>
      </Box.Header>
    )
  }

  renderBodyOverview() {
    let {income,payment_type,profit} = this.state
    let count_work_amount = 0
    let count_work_approved =0
    let count_work_received =0
    let sum_amount = 0
    let sum_approved_amount = 0
    let sum_received_amount = 0
    let sum_wage_price = 0
    let sum_approved_wage_price = 0
    let sum_part_price = 0
    let sum_approved_part_price = 0
    let countOfWorkPerType = payment_type.map((item,index)=>{
        var found = income.find((element)=> {
          return element.payment_type===item
        });
        let count_work = (found!==undefined)?found.count_work*1:0
        count_work_approved += (found!==undefined)?found.count_work_approved*1:0
        count_work_received += (found!==undefined)?found.count_work_received*1:0
        sum_amount += (found!==undefined)?found.sum_amount*1:0
        sum_approved_amount += (found!==undefined)?found.sum_approved_amount*1:0
        sum_received_amount += (found!==undefined)?found.sum_received_amount*1:0
        sum_wage_price += (found!==undefined)?found.sum_wage_price*1:0
        sum_approved_wage_price += (found!==undefined)?found.sum_approved_wage_price*1:0
        sum_part_price += (found!==undefined)?found.sum_part_price*1:0
        sum_approved_part_price += (found!==undefined)?found.sum_approved_part_price*1:0        
        count_work_amount += count_work*1
        
        return (<li key={index}><a href="#">{messages['Number of cars']} ({paymentType[item].title})<span className="pull-right badge bg-blue" id="count-work-cash">{count_work} {messages['carr']}</span></a></li>)                
    })
    count_work_amount = (count_work_amount*1)
    count_work_approved = (count_work_approved*1)
    count_work_received = (count_work_received*1)
    sum_amount = (sum_amount*1)
    sum_wage_price = (sum_wage_price*1)
    sum_part_price = (sum_part_price*1)
    sum_approved_amount = (sum_approved_amount*1)
    sum_received_amount = (sum_received_amount*1)
    sum_approved_wage_price = (sum_approved_wage_price*1)
    sum_approved_part_price = (sum_approved_part_price*1)
    let count_work_balance = count_work_approved - count_work_received
    let sum_balance_amount = sum_approved_amount - sum_received_amount
    return(
      <Box.Body className="no-padding">
        <ul className="nav nav-stacked">
          <li className='disabled bg-gray-active'><FontAwsome name='car'/> {messages['Number of jobs']}</li>
        {countOfWorkPerType}
          <li><a href="#">{messages['Quantity']} ({messages['Grand total']})<span className="pull-right badge bg-blue" id="sum-work">{this.getNumberFormat(count_work_amount,0)} {messages['carr']}</span></a></li>
          <li><a href="#">{messages['Quantity']} ({messages['Approve']})<span className="pull-right badge bg-blue" id="sum-work">{this.getNumberFormat(count_work_approved,0)} {messages['carr']}</span></a></li>
          <li><a href="#">{messages['Quantity']} ({messages['Charged']})<span className="pull-right badge bg-blue" id="sum-work">{this.getNumberFormat(count_work_received,0)} {messages['carr']}</span></a></li>
          <li><a href="#">{messages['Quantity']} ({messages['Charged balance']})<span className="pull-right badge bg-blue" id="sum-work">{this.getNumberFormat(count_work_balance,0)} {messages['carr']}</span></a></li>
          <li className='disabled bg-gray-active'><FontAwsome name='money'/> {messages['Total revenue']}</li>
          <li><a href="#">{messages['Total revenue']} ({messages['Offer']})<span className="pull-right badge bg-aqua" id="sum-amount">{this.getNumberFormat(sum_amount)} {messages['Bath']}</span></a></li>
          <li><a href="#">{messages['Total revenue']} ({messages['Approve']})<span className="pull-right badge bg-aqua" id="sum-approved-amount">{this.getNumberFormat(sum_approved_amount)} {messages['Bath']}</span></a></li>
          <li><a href="#">{messages['Total revenue']} ({messages['Charged']})<span className="pull-right badge bg-aqua" id="sum-approved-amount">{this.getNumberFormat(sum_received_amount)} {messages['Bath']}</span></a></li>
          <li><a href="#">{messages['Total revenue']} ({messages['Charged balance']})<span className="pull-right badge bg-aqua" id="sum-approved-amount">{this.getNumberFormat(sum_balance_amount)} {messages['Bath']}</span></a></li>
          <li className='disabled bg-gray-active'><FontAwsome name='money'/> {messages['Wages cost and Parts cost']}</li>
          <li><a href="#">{messages['Wages cost']} ({messages['Offer']})<span className="pull-right badge bg-gray-active" style={{color:'#333'}} id="sum-wage-price">{this.getNumberFormat(sum_wage_price)} {messages['Bath']}</span></a></li>
          <li><a href="#">{messages['Wages cost']} ({messages['Approve']})<span className="pull-right badge bg-gray-active" style={{color:'#333'}} id="sum-approved-wage-price">{this.getNumberFormat(sum_approved_wage_price)} {messages['Bath']}</span></a></li>
          <li><a href="#">{messages['Parts cost']} ({messages['Offer']})<span className="pull-right badge bg-green" id="sum-part-price">{this.getNumberFormat(sum_part_price)} {messages['Bath']}</span></a></li>
          <li><a href="#">{messages['Parts cost']} ({messages['Approve']})<span className="pull-right badge bg-green" id="sum-approved-part-price">{this.getNumberFormat(sum_approved_part_price)} {messages['Bath']}</span></a></li>
          
          {profit.itemlist && profit.itemlist.length > 0 && (<li className='disabled bg-gray-active'><FontAwsome name='money'/> {'ประเมินกำไร '}</li>)}
          {
            profit.itemlist && (profit.itemlist.map((item,index)=>(
              <li>
                <a href="#">{item.title} <span className="pull-right badge bg-gray-active" style={{color:'#333'}} >{this.getNumberFormat(item.amount)} {messages['Bath']}</span></a>
                <span style={{fontSize:"13px"}}>{item.description}</span>
              </li>              
            )))
          }          
        </ul>
      </Box.Body>
    )
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadInsureStat(this.state.activeName,this.state.year,this.state.month,val.value,this.state.viewForm)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadInsureStat(this.state.activeName,this.state.year,val.value,_day,this.state.viewForm)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadInsureStat(this.state.activeName,val.value,this.state.month,_day,this.state.viewForm)
  }

  onExportExcelDetail(type,e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById((type==='insurer'?this.refTableDetailId:type==='cash'?this.refCashTableDetailId:this.refEmpTableDetailId)));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    const fileName = messages['Revenue summary report']+(this.state.activeName==='insurer'?messages['Insurance']:this.state.activeName==='emp'?messages['Employee quotation']:messages['Cash'])+(this.state.job_type==='work'?messages['Set payment']:this.state.job_type==='received'?messages['Received']:this.state.job_type==='balance'?messages['Balance']:'')+' ('+messages['Monthly']+').xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTableDetail(e) {
    const {activeName,insurer_id,owner_id,work_owner_id,job_type} = this.state
    let url = ''
    let param = 'PrintReportSummaryDetailInsure&type='+activeName+'&job_type='+job_type+'&id='+(activeName==='insurer'?insurer_id:activeName==='emp'?work_owner_id:owner_id)+'&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day
    if (process.env.NODE_ENV === "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcel(type,e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById((type==='insurer'?this.refTableId:type==='cash'?this.refCashTableId:this.refEmpTableId)));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = messages['Revenue summary report']+(this.state.activeName==='insurer'?messages['Insurance']:this.state.activeName==='emp'?messages['Employee quotation']:messages['Cash'])+' ('+messages['Monthly']+').xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange,activeName,viewForm} = this.state
    let url = ''
    let param = 'PrintReportSummary&type='+activeName+'&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&isRange=false&viewForm='+viewForm
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month==='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportSummary&type='+activeName+'&start_date='+start+'&end_date='+end+'&isRange=true&viewForm='+viewForm
    }    

    if (process.env.NODE_ENV === "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!==''&&time!==undefined&&time!==null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadInsureStat(this.state.activeName,_year,_month,_day,this.state.viewForm)
    }
  }

  onEndDateRangeChange(time) {
    if (time!==''&&time!==undefined&&time!==null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month==='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadInsureStatRange(this.state.activeName,start,end,this.state.viewForm)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadInsureStatRange(this.state.activeName,start,end,this.state.viewForm)
  }

  onViewFormChange(field) {
    this.setState({viewForm:field,isRange:false})
    this.loadInsureStat(this.state.activeName,this.state.year,this.state.month,this.state.day,field)
    localStorage.setItem(localStorageKey, JSON.stringify(field))
  }

  onWorkStatusChange(e) {
    let {work_status} = this.state
    let status_list = []
    if (e!==''&&e!==null&&e!==undefined)
      status_list = e.split(',')
    
    let new_work_status = []
    status_list.forEach((item,index)=>{
      if (new_work_status.indexOf(item)===-1)
        new_work_status.push(item)
    })  

    work_status = new_work_status.join()
    this.setState({work_status:work_status},()=>{
      this.loadInsureStat(this.state.activeName,this.state.year,this.state.month,this.state.day,this.state.viewForm)
    })
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day==='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month==='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange==='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange==='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbarDetail(type) {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <PrintButtons
            onPrintTable={this.onPrintTableDetail.bind(this)}
            onExportExcel={this.onExportExcelDetail.bind(this,type)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderToolbar(type) {
    let {viewForm} = this.state
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this,type)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
        {' '}
        <FormGroup>
          {messages['See data from']}&nbsp;
          <Radio
            radioClass="iradio_square-blue"
            increaseArea="20%"
            checked={viewForm==='added_date'?true:false}
            onChange={this.onViewFormChange.bind(this,'added_date')}
            label={' '+messages['Login date']}
          />
          &nbsp;
          <Radio
            radioClass="iradio_square-blue"
            increaseArea="20%"
            checked={viewForm==='entrance_date'?true:false}
            onChange={this.onViewFormChange.bind(this,'entrance_date')}
            label={' '+messages['Repair date']}
          />
          &nbsp;
          <Radio
            radioClass="iradio_square-blue"
            increaseArea="20%"
            checked={viewForm==='finance_date'?true:false}
            onChange={this.onViewFormChange.bind(this,'finance_date')}
            label={' '+messages['Wait for set payment date']}
          />
        </FormGroup>
        {' '}
        <FormGroup>
          <Select
            style={{width:'377px'}}
            multi={true}
            removeSelected={false}
            simpleValue={true}
            clearable={false}
            placeholder={messages['Select']}
            value={this.state.work_status}
            options={this.state.work_status_option}
            onChange={this.onWorkStatusChange.bind(this)}
          />
        </FormGroup>  
      </Form>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange===0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadInsureStat(this.state.activeName,this.state.year,this.state.month,this.state.day,this.state.viewForm)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  onInsureTypeSelect(type='insurer',e) {
    this.setState({isRange:false})
    if (type==='insurer')
      this.setState({insureDataType:e})
    else if (type==='cash')
      this.setState({cashDataType:e})
    else if (type==='emp')
      this.setState({empDataType:e})    
    setTimeout(()=>{
      this.loadInsureStat(this.state.activeName,this.state.year,this.state.month,this.state.day,this.state.viewForm)
    },100)
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwsome name='eraser' />&nbsp;{messages['Delete period']}</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  onRowDetailClick(item,job_type) {
    let {year,month,day,activeName,viewForm} = this.state
    let id = activeName==='insurer'?item.insurer_id:activeName==='emp'?item.work_owner_by:item.owner_name
    this.loadDataDetail(activeName,job_type,id,year,month,day,viewForm,(result)=>{
      if (result==='OK') {
        this.setState({showDetail:true,job_type:job_type})
        if (activeName==='insurer')
          this.setState({insurer_id:id})
        else if (activeName==='emp')
          this.setState({work_owner_id:id})
        else
          this.setState({owner_id:id})
      }  
    })
  }

  onRowDetailClose() {
    let {year,month,activeName} = this.state
    let date = year-543+'-'+month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.loadInsureStat(activeName,year,month,_day,this.state.viewForm)
    this.setState({day:_day,showDetail:false,job_type:'work',insurer_id:null,owner_id:null,work_owner_id:null})
  }

  renderInsureRowData(type) {
    let {insuredata,cashdata,officerdata} = this.state
    let data = type==='insurer'?insuredata:type==='emp'?officerdata:cashdata
    if (data.length===0) {
      return(<tr><td colSpan={type==='emp'?6:17}>{messages['No data']}</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-left'>{type==='insurer'?item.insurer_name:type==='emp'?item.work_owner_by:item.owner_name}</td>
              <td className='text-center'><Button bsSize='xs' onClick={this.onRowDetailClick.bind(this,item,'work')}><FontAwsome name='search' /></Button> {item.work_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.work_amount)}</td>
              <td className='text-center'>{item.work_approved_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.work_approved_amount)}</td>
              {type==='emp'?'':<td className='text-center'><Button bsSize='xs' onClick={this.onRowDetailClick.bind(this,item,'unprocess')}><FontAwsome name='search' /></Button> {item.unprocess_finance_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.unprocess_finance_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.unprocess_approved_amount)}</td>}
              {type==='emp'?'':<td className='text-center'><Button bsSize='xs' onClick={this.onRowDetailClick.bind(this,item,'process')}><FontAwsome name='search' /></Button> {item.process_finance_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.process_finance_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.process_approved_amount)}</td>}
              {type==='emp'?'':<td className='text-center'><Button bsSize='xs' onClick={this.onRowDetailClick.bind(this,item,'received')}><FontAwsome name='search' /></Button> {item.received_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.received_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.received_approved_amount)}</td>}
              {type==='emp'?'':<td className='text-center'><Button bsSize='xs' onClick={this.onRowDetailClick.bind(this,item,'balance')}><FontAwsome name='search' /></Button> {item.balance_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.balance_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.balance_approved_amount)}</td>}
            </tr>
          )
        })
      )
    }
  }

  renderInsureTable(type='insurer') {
    return (
      <div className='display-overflow'>
        <table id={(type==='insurer'?this.refTableId:type==='cash'?this.refCashTableId:this.refEmpTableId)} className='table table-responsive table-hover table-bordered-solid' style={{minWidth:(type==='emp'?'0':'1800px')}}>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center' style={{width:'30px'}}>#</th>
              <th rowSpan={2} className='text-center' style={{width:'200px'}}>{type==='insurer'?messages['Insurance company']:type==='emp'?messages['Employee owner']:messages['Owner']}</th>
              <th colSpan={4} className='text-center'>{type==='emp'?messages['Worksheet list']:messages['Finished work']}</th>
              {type==='emp'?'':<th colSpan={3} className='text-center'>{messages['Waiting receive money']}</th>}
              {type==='emp'?'':<th colSpan={3} className='text-center'>{messages['Set payment']}</th>}
              {type==='emp'?'':<th colSpan={3} className='text-center'>{messages['Received']}</th>}
              {type==='emp'?'':<th colSpan={3} className='text-center'>{messages['Waiting receive money']}</th>}
            </tr>
            <tr>
              <th className='text-center' style={{width:'90px'}}>{messages['Job']}</th>
              <th className='text-center' style={{width:'90px'}}>{messages['Offer']}</th>
              <th className='text-center' style={{width:'90px'}}>{messages['Job']}</th>
              <th className='text-center' style={{width:'90px'}}>{messages['Approve']}</th>
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Job']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Offer']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Approve']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Job']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Offer']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Approve']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Job']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Offer']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Approve']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Job']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Offer']}</th>}
              {type==='emp'?'':<th className='text-center' style={{width:'90px'}}>{messages['Approve']}</th>}
            </tr>
          </thead>
          <tbody>
            {this.renderInsureRowData(type)}
          </tbody>
          <tfoot>
            <tr>
              <th  colSpan='2' className='text-right'>{messages['Net total']}</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary(type,'work_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary(type,'work_amount'))}</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary(type,'work_approved_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary(type,'work_approved_amount'))}</th>
              {type==='emp'?'':<th className='text-center'>{this.getNumberFormat(this.getSummary(type,'unprocess_finance_count'),0)}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'unprocess_finance_amount'))}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'unprocess_approved_amount'))}</th>}
              {type==='emp'?'':<th className='text-center'>{this.getNumberFormat(this.getSummary(type,'process_finance_count'),0)}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'process_finance_amount'))}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'process_approved_amount'))}</th>}
              {type==='emp'?'':<th className='text-center'>{this.getNumberFormat(this.getSummary(type,'received_count'),0)}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'received_amount'))}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'received_approved_amount'))}</th>}
              {type==='emp'?'':<th className='text-center'>{this.getNumberFormat(this.getSummary(type,'balance_count'),0)}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'balance_amount'))}</th>}
              {type==='emp'?'':<th className='text-right'>{this.getNumberFormat(this.getSummary(type,'balance_approved_amount'))}</th>}
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onIconClick(workNo,e) {
    this.refs.jsWork.loadData(workNo)
  }

  renderDetailRowData() {
    let {dataDetail} = this.state
    if (dataDetail.length===0) {
      return(<tr><td colSpan={9}>{messages['No data']}</td></tr>)
    } else {
      return(
        dataDetail.map((item,index)=>{
          let title = "ใบงานซ่อม "+item['work_no']
          let popoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title={title}>
              <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
            </Popover>
          )
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>
                {item.work_no}&nbsp;
                <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}>
                  <FontAwsome onClick={this.onIconClick.bind(this,item.work_no)} className="text-blue" name='file-text-o'/>
                </OverlayTrigger>
              </td>
              <td className='text-center'>{item.work_date}</td>
              <td className='text-center'>{item.customer_name}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.brand }</td>
              <td className='text-center'>{item.model}</td>
              <td className='text-right'>{this.getNumberFormat(item.quotation_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
            </tr>
          )
        })
      )
    }
  } 

  renderTableDetail(type='insurer') {
    return (
      <div className='display-overflow'>
        <table id={(type==='insurer'?this.refTableDetailId:type==='cash'?this.refCashTableDetailId:this.refEmpTableDetailId)} className='table table-responsive table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
          <thead>
            <tr>
              <th className='text-center' style={{width:'50px'}}>{messages['Number']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Worksheet number']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Date']}</th>
              <th className='text-center' style={{width:'150px'}}>{messages['Customer name']}</th>
              <th className='text-center' style={{width:'110px'}}>{messages['Car registration']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Brand']}</th>
              <th className='text-center' style={{width:'90px'}}>{messages['Model']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Quotation price']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Approval price']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderDetailRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={7} className='text-right'>{messages['Net total']}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummaryDetail('quotation_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummaryDetail('approved_amount'))}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderDropdownInsureType(type='insurer',title) {
    let {insureDataType,cashDataType,empDataType} = this.state
    let dataType = type==='insurer'?insureDataType:type==='emp'?empDataType:cashDataType
    return(
                      <DropdownButton id="dd-insure-type" bsStyle="link" title={title} onSelect={this.onInsureTypeSelect.bind(this,type)}>
                        <MenuItem eventKey={'count'}> 
                          <Radio
                            radioClass="iradio_flat-blue"
                            increaseArea="20%"
                            disabled={dataType==='count'?false:true}
                            checked={dataType==='count'?true:false}
                          >
                          </Radio> {messages['Number of jobs']}
                        </MenuItem>
                        <MenuItem eventKey={'amount'}> 
                          <Radio
                            radioClass="iradio_flat-blue"
                            increaseArea="20%"
                            disabled={dataType==='amount'?false:true}
                            checked={dataType==='amount'?true:false}
                          >
                          </Radio> {messages['Amount']}
                        </MenuItem>
                      </DropdownButton>
    )
  }

  renderInsureTab(type='insurer') {
    let {insuredata,cashdata,officerdata,checkDataFinance,checkDataReceived,checkCashDataFinance,checkCashDataReceived,insureDataType,empDataType,cashDataType,showDetail} = this.state
    const dataType = type==='insurer'?insureDataType:type==='emp'?empDataType:cashDataType
    const finance = type==='insurer'?checkDataFinance:checkCashDataFinance
    const received = type==='insurer'?checkDataReceived:checkCashDataReceived
    const title1 = (<span>{messages['Set payment']} <small>({dataType==='count'?messages['Number of jobs']:messages['Amount']})</small></span>)
    const title2 = (<span>{messages['Received']} <small>({dataType==='count'?messages['Number of jobs']:messages['Amount']})</small></span>)
    const data = type==='insurer'?insuredata:type==='emp'?officerdata:cashdata
    return(
        <div>
          <Box>
            <Box.Body>
              {data.length>0&&!showDetail&&type!=='emp'
              ?
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={2} className='text-center'></Col>
                    <Col md={4} className='text-center'>
                      {this.renderDropdownInsureType(type,title1)}
                      <div className="chart-container">
                        <center>
                          <div className="chart-container" style={{ height:"400px", width:"400px"}}>
                            {type==='insurer'
                            ?
                            <canvas 
                              ref={(canvas) => { this.canvasInsureRef1 = canvas; }}
                              width="100" height="100"
                            >
                            </canvas>
                            :
                            <canvas 
                              ref={(canvas) => { this.canvasCashRef1 = canvas; }}
                              width="100" height="100"
                            >
                            </canvas>
                            }
                          </div>
                          {!finance?<h3 style={{position:'absolute',top:'30%',right:'0',bottom:'0',left:'0'}}>{messages['No data']}</h3>:''}
                        </center>                   
                      </div>
                    </Col> 
                    <Col md={4} className='text-center'> 
                      {this.renderDropdownInsureType(type,title2)}
                      <div className="chart-container">
                        <center>
                          <div className="chart-container" style={{ height:"400px", width:"400px"}}>
                            {type==='insurer'
                            ?
                            <canvas 
                              ref={(canvas) => { this.canvasInsureRef2 = canvas; }}
                              width="100" height="100"
                            >
                            </canvas>
                            :
                            <canvas 
                              ref={(canvas) => { this.canvasCashRef2 = canvas; }}
                              width="100" height="100"
                            >
                            </canvas>
                            }
                          </div>  
                          {!received?<h3 style={{position:'absolute',top:'30%',right:'0',bottom:'0',left:'0'}}>{messages['No data']}</h3>:''}
                        </center>               
                      </div>
                    </Col>
                    <Col md={2} className='text-center'></Col>
                  </Row>
                </Col>
              </Row>
              :''}
              <Row style={{marginTop:data.length>0&&!showDetail&&type!=='emp'?'20px':'0'}}>
                <Col md={12}>
                  {!showDetail?this.renderToolbar(type):''}
                  {!showDetail?this.renderDateRange():''}
                  {!showDetail?this.renderInsureTable(type):''}  
                  {showDetail? 
                  <Breadcrumb>
                    <Breadcrumb.Item active={false} onClick={this.onRowDetailClose.bind(this)}>
                      <FontAwsome name='table' /> {messages['Main table']}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active={true} onClick={()=>{}}>
                      {messages['Revenue summary']}{this.state.activeName==='insurer'?messages['Insurance']:this.state.activeName==='emp'?messages['Employee quotation']:messages['Cash']}{this.state.job_type==='work'?messages['Set payment']:this.state.job_type==='received'?messages['Received']:this.state.job_type==='balance'?messages['Balance']:''}
                    </Breadcrumb.Item>    
                  </Breadcrumb>
                  :''}
                  {showDetail?this.renderToolbarDetail(type):''}
                  {showDetail?this.renderTableDetail(type):''}
                </Col>
              </Row>
            </Box.Body>
            {showDetail?
            <Box.Footer>
              <div className='pull-right'>
                <Button onClick={this.onRowDetailClose.bind(this)}><FontAwsome name='table' /> {messages['Back to main table']}</Button>    
              </div>
            </Box.Footer>
            :''}
          </Box>    
        </div>    
    )
  }

  render() {
    let {payment_type,activeKey,amountType,viewForm} = this.state
    const title = (<span><FontAwsome name='pie-chart' />&nbsp;{messages['Overview']}</span>)
    const title1 = (<span><FontAwsome name='university' />&nbsp;{messages['Insurance']}</span>)
    const title2 = (<span><FontAwsome name='money' />&nbsp;{messages['Cash']}</span>)
    const title3 = (<span><FontAwsome name='users' />&nbsp;{messages['Employee quotation']}</span>)
    return(
      <div>
        <Tabs 
            defaultActiveKey={0}
            activeKey={activeKey}
            animation={false} 
            id="main-dashboard-tabs"
            onSelect={this.onTabSelect.bind(this)}
        >
          <Tab
            eventKey={0}
            title={title}
          >
            <Row>
              <Col md={4}>
                <Box>
                  {this.renderHeaderOverview()}
                  {this.renderBodyOverview()}
                </Box>
              </Col>
              <Col md={8}>
                <Row>
                  <Col md={6}>
                    <Box>
                      <Box.Header border={true}>
                        <Box.Title>
                          <i className="fa fa-money"></i>&nbsp;{messages['Show price from']}  
                        </Box.Title>
                      </Box.Header>
                      <Box.Body className="no-padding">
                        <RadioGroup name="radio" value={amountType} onChange={this.onAmountTypeChange.bind(this)}>                  
                          <Radio
                            value="quotation"
                            radioClass="iradio_square-blue"
                            increaseArea="20%"
                            label={' '+messages['Quotation price']}
                          />
                          <Radio
                            value="approved"
                            radioClass="iradio_square-blue"
                            increaseArea="20%"
                            label={' '+messages['Approval price']}
                          />
                        </RadioGroup>
                      </Box.Body>
                    </Box>
                  </Col>  
                  <Col md={6}>  
                    <Box>
                      <Box.Header border={true}>
                        <Box.Title>
                          <i className="fa fa-calendar"></i>&nbsp;{messages['See data from day']}  
                        </Box.Title>
                      </Box.Header>
                      <Box.Body className="no-padding">
                        <RadioGroup name="radio" value={viewForm} onChange={this.onViewFormDashboardChange.bind(this)}>                  
                          <Radio
                            value="added_date"
                            radioClass="iradio_square-blue"
                            increaseArea="20%"
                            label={' '+messages['Login date']}
                          />
                          <Radio
                            value="entrance_date"
                            radioClass="iradio_square-blue"
                            increaseArea="20%"
                            label={' '+messages['Repair date']}
                          />
                          <Radio
                            value="finance_date"
                            radioClass="iradio_square-blue"
                            increaseArea="20%"
                            label={' '+messages['Wait for set payment date']}
                          />
                        </RadioGroup>
                      </Box.Body>
                    </Box>
                  </Col>
                </Row>  
                <Box>
                  <Box.Header border={true}>
                    <Box.Title>
                      <i className="fa fa-pie-chart"></i>&nbsp;{messages['Percentage Overview']} - <a href="#"> {this.convertMonth(this.state.month_dashboard)}</a> 
                    </Box.Title>  
                  </Box.Header>
                  <Box.Body className="no-padding">
                    <Row>
                      <Col md={6}>
                        <div className="chart-container" style={{ height:"400px", width:"400px"}}>
                            <canvas 
                              ref={(canvas) => { this.canvasDoughnutRef = canvas; }}
                              width="100" height="100"
                            >
                            </canvas>                 
                        </div>
                      </Col> 
                      <Col md={6}> 
                        <div className="chart-container" style={{ height:"400px", width:"400px"}}>
                            <canvas 
                              ref={(canvas2) => { this.canvasDoughnutRef2 = canvas2; }}
                              width="100" height="100"
                            >
                            </canvas>                 
                        </div>
                      </Col> 
                    </Row>    
                  </Box.Body>
                </Box>
              </Col>
            </Row>  
            <Row>
              <Col md={4}></Col>  
              <Col md={8}>
                <Box>
                  <Box.Header border={true}>
                    <Box.Title>
                      <i className="fa fa-bar-chart-o"></i>&nbsp;{messages['Graph Show Revenue']}
                      {payment_type.map((item,index)=>(
                        <span key={index} className="badge " style={{color:(paymentType[item].color==='#b5bbc8'||paymentType[item].color==='yellow'?'#333':''),backgroundColor:(paymentType[item].color)}}>{paymentType[item].title}</span>  
                      ))}                  
                    </Box.Title>  
                  </Box.Header>
                  <Box.Body className="no-padding">
                    <div className="chart-container" style={{ height:"auto", width:"100%"}}>
                      <canvas 
                        ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}
                      >
                      </canvas>  
                    </div>  
                  </Box.Body>
                </Box>
              </Col>
            </Row>
            <Row>
              <Col md={4}></Col>  
              <Col md={8}>
                <Box>
                  <Box.Header border={true}>
                    <Box.Title>
                      <i className="fa fa-bar-chart-o"></i>&nbsp;{messages['Graph Show Revenue']}
                      <span className="badge bg-gray-active" style={{color:'#333'}}>{messages['Wages']}</span><span className="badge bg-green">{messages['Parts']}</span>
                    </Box.Title>  
                  </Box.Header>
                  <Box.Body className="no-padding">
                    <div className="chart-container" style={{ height:"auto", width:"100%"}}>
                      <canvas 
                        ref={(canvasBar2) => { this.canvasBarRef2 = canvasBar2; }}
                      >
                      </canvas>  
                    </div>
                  </Box.Body>
                </Box>
              </Col>
            </Row>
          </Tab>
          <Tab
            eventKey={1}
            title={title1}
          >
            <Row>
              <Col md={12}>
                {this.renderInsureTab('insurer')}
              </Col>
            </Row>
          </Tab>
          <Tab
            eventKey={2}
            title={title2}
          >
            <Row>
              <Col md={12}>
                {this.renderInsureTab('cash')}
              </Col>
            </Row>
          </Tab>
          <Tab
            eventKey={3}
            title={title3}
          >
            <Row>
              <Col md={12}>
                {this.renderInsureTab('emp')}
              </Col>
            </Row>
          </Tab>                
        </Tabs>
        <IframeModal ref='iframe' title={messages['Print document']} />
        <JSWorkDocViewModal ref="jsWork" title={'แสดงผลใบงาน '} modal={true} fullScreen={true}/>
      </div>  
    )
  }
}

export default MainDashboard;    



// WEBPACK FOOTER //
// ./src/view/dashboard/MainDashboard.js